<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%;">
      <AdminSideBarMenu />
      <v-flex v-if="isSelectedTab('all')" class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin Tutorials</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">All Tutorials</v-breadcrumbs-item>
        </v-breadcrumbs>
        <all-tutorial />
      </v-flex>
      <v-flex v-if="isSelectedTab('manage')" class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin Tutorials</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Manage Tutorials</v-breadcrumbs-item>
        </v-breadcrumbs>
        <tutorial-table />
      </v-flex>
      <v-flex v-if="isSelectedTab('tutorial-new')" class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin Tutorials</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Add New Tutorial</v-breadcrumbs-item>
        </v-breadcrumbs>
        <new-tutorial/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import AdminSideBarMenu from './Components/AdminSideBar'
  import AllTutorial from './Tutorial/AllTutorials'
  import TutorialTable from './Tutorial/TutorialTable'
  import NewTutorial from './Tutorial/NewTutorial'

  export default {
    components: {
      AdminSideBarMenu,
      AllTutorial,
      TutorialTable,
      NewTutorial
    },
    methods: {
      isSelectedTab (tabName) {
        const urlSection = this.$route.params.id || 'general-settings'
        return tabName === urlSection
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// TutorialView.vue?fbb60d9e